var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardDisplacement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "30px",
    viewBox: "0 0 13.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,5000 L0,5000 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C12.5522847,0 13,0.44771525 13,1 L13,29 C13,29.5522847 12.5522847,30 12,30 L1,30 C0.44771525,30 0,29.5522847 0,29 L0,1 C0,0.44771525 0.44771525,0 1,0 L12,0 Z M11,2 L2,2 L2,28 L11,28 L11,26 L7,26 C6.44771525,26 6,25.5522847 6,25 C6,24.4477153 6.44771525,24 7,24 L11,24 L11,22 L5,22 C4.44771525,22 4,21.5522847 4,21 C4,20.4477153 4.44771525,20 5,20 L11,20 L11,18 L7,18 C6.44771525,18 6,17.5522847 6,17 C6,16.4477153 6.44771525,16 7,16 L11,16 L11,14 L5,14 C4.48716416,14 4.06449284,13.6139598 4.00672773,13.1166211 L4,13 C4,12.4477153 4.44771525,12 5,12 L11,12 L11,10 L7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 L11,8 L11,6 L5,6 C4.44771525,6 4,5.55228475 4,5 C4,4.44771525 4.44771525,4 5,4 L11,4 L11,2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1147.0 -1465.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1168.7027957955106 1464.797204204489) scale(-1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.702795795510834 0.20279579551083948)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13,0 13,30 0,30 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDisplacement);
export default __webpack_public_path__ + "static/media/DashboardDisplacement.8423e4bdf3947d878fe42c69ea4a8a91.svg";
export { ForwardRef as ReactComponent };